import { FC } from "react";
import ServicesModalWrapper from "./modal-wrappers/ServicesModalWrapper";
import { Button, message, Modal } from "antd";
import { RiLinkM } from "react-icons/ri";
import { useIntl } from "react-intl";
import { AiOutlineGlobal } from "react-icons/ai";
import { location } from "../../../../types/calendar";
import { catalogSVG, copySVG, servicesSVG } from "../../../../assets/SVGs/SVGs";
import { deleteSVG } from "../../../../assets/catalog/SVGs";

interface ServicesDirectLinkProps {
  locationLinksData: location;
  isLoading: boolean;
  handleRemoveLink: (params: any) => Promise<void>;
  handleCreateLink: (params: any) => Promise<void>;
  servicesModal: boolean;
  setServicesModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const ServicesDirectLink: FC<ServicesDirectLinkProps> = ({
  handleCreateLink,
  handleRemoveLink,
  isLoading,
  locationLinksData,
  servicesModal,
  setServicesModal,
}) => {
  const intl = useIntl();
  const domain = window.location.origin;

  return (
    <div className="bg-white px-6 py-2 rounded   ">
      <div>
        {locationLinksData?.have_service_link ? (
          <div className="bg-[#EEF0FF] p-4 rounded w-[750px] flex gap-2 justify-between">
            <div className="flex gap-2 items-center">
              <div className="flex gap-2 p-3 bg-white rounded-full">
                <p className="flex gap-1 items-center text-[#479821]">
                  <AiOutlineGlobal />
                  <span>Services link</span>
                </p>
              </div>
              <p className="text-color-primary flex gap-2 ">
                <RiLinkM size={22} />
                <span>{domain + "/" + locationLinksData?.slug}</span>
              </p>
            </div>
            <div className="flex  items-center">
              <Button
                type="text"
                size="small"
                htmlType="button"
                loading={isLoading}
                onClick={() => {
                  navigator.clipboard.writeText(
                    domain + "/" + locationLinksData?.slug
                  );
                  message.success(intl.formatMessage({ id: "copy_link" }));
                }}
              >
                {copySVG}
              </Button>
              <Button
                type="text"
                size="small"
                loading={isLoading}
                onClick={() => {
                  handleRemoveLink({
                    links: [
                      {
                        link_type: "service_link",
                        value: 0,
                      },
                    ],
                  });
                }}
              >
                {deleteSVG}
              </Button>
            </div>
          </div>
        ) : (
          <div className="flex flex-col items-center space-y-2  border border-solid border-gray-200  rounded-md p-4">
            <div className="flex flex-col items-center space-y-2">
              <div>{catalogSVG}</div>
              <div>
                <div className="text-center space-y-3">
                  <p className="text-color-primary font-semibold">
                    Services link{" "}
                  </p>
                </div>
              </div>
            </div>
            <Button
              type="default"
              htmlType="button"
              block
              className="bg-[#EEF0FF] flex justify-center items-center"
              onClick={() => {
                setServicesModal(true);
              }}
              icon={<RiLinkM size={18} color="#00086D" />}
              loading={isLoading}
            >
              <span className="text-color-primary">
                {intl.formatMessage({ id: "create_link" })}
              </span>{" "}
            </Button>
          </div>
        )}
      </div>

      <div>
        <Modal
          className="md:min-w-[550px]"
          maskClosable={false}
          open={servicesModal}
          onCancel={() => setServicesModal(false)}
          destroyOnClose
          footer={null}
        >
          <ServicesModalWrapper
            handleCreateLink={handleCreateLink}
            handleRemoveLink={handleRemoveLink}
            isLoading={isLoading}
            locationLinksData={locationLinksData}
          />
        </Modal>
      </div>
    </div>
  );
};

export default ServicesDirectLink;
